import {writable} from "svelte/store";


/**
 *
 *

 */
export const connections = writable({
    sets : {
        local: {
            mimesisUI_URL: 'http://localhost:9191/shared.ui/ui',
            mimesisCombinedUI_URL: 'http://localhost:9191/shared.ui/combineddescription',
            mimesisResources_URL: 'http://localhost:9191/shared.ui/resource',
            mimesisAppModelOntology_URL: 'http://localhost:9191/shared.ui/ontology',
            mimesisAbstractUI_URL: 'http://localhost:9191/shared.ui/mimesisui'
        },
        default : {
            mimesisUI_URL: 'http://ui.dsrv1.mimesis.solutions/shared.ui/ui',
            mimesisCombinedUI_URL: 'http://ui.dsrv1.mimesis.solutions/shared.ui/combineddescription',
            mimesisResources_URL: 'http://ui.dsrv1.mimesis.solutions/shared.ui/resource',
            mimesisAppModelOntology_URL: 'http://ui.dsrv1.mimesis.solutions/shared.ui/ontology',
            mimesisAbstractUI_URL: 'http://ui.dsrv1.mimesis.solutions/shared.ui/mimesisui'
        }
    }
});
